import Axios from "axios";
import Authorization from './auth';
import { executeCall } from "./utils";

const admin = (domain, resource, withAuth = true) => {
    const url = `${domain}/${resource}`;
    const getHeaders = () => withAuth ? Authorization() : {};

    return {
        getStats: () => executeCall(() => Axios.get(`${url}/stats`, { headers: getHeaders() })),
        
        getUsers: (params) => executeCall(() => Axios.get(`${url}/users`, { params, headers: getHeaders() })),
        
        createUser: (data) => executeCall(() => Axios.post(`${url}/users`, data, { headers: getHeaders() })),
        
        getUserById: (id) => executeCall(() => Axios.get(`${url}/users/${id}`, { headers: getHeaders() })),

        getPendingTherapists: () => executeCall(() => Axios.get(`${url}/therapists/pending`, { headers: getHeaders() })),

        getTherapists: (params = {}) => executeCall(() =>
            Axios.get(`${url}/therapists`, { params, headers: getHeaders() })
        ),

        updateUser: (id, data) => executeCall(() => Axios.put(`${url}/users/${id}`, data, { headers: getHeaders() })),

        deleteUser: (id) => executeCall(() => Axios.delete(`${url}/users/${id}`, { headers: getHeaders() })),
        toggleUserStatus: (id) => executeCall(() => Axios.patch(`${url}/users/${id}/toggle-status`, {}, { headers: getHeaders() })),
        resetUserPassword: (id, newPassword) => executeCall(() => Axios.patch(`${url}/users/${id}/reset-password`, { newPassword }, { headers: getHeaders() })),
        
        approveTherapist: (id, data) => executeCall(() => 
            Axios.put(`${url}/therapists/${id}/approve`, { action: 'approve', comments: data?.comments || '' }, { headers: getHeaders() })
        ),
        
        rejectTherapist: (id, data) => executeCall(() => 
            Axios.put(`${url}/therapists/${id}/reject`, { action: 'reject', comments: data?.reason || '' }, { headers: getHeaders() })
        ),
        
        getReviews: (params) => executeCall(() => Axios.get(`${url}/reviews`, { params, headers: getHeaders() })),
        
        moderateReview: (id, data) => executeCall(() => 
            Axios.put(`${url}/reviews/${id}/moderate`, data, { headers: getHeaders() })
        ),

        // Businesses
        getBusinesses: (params) => executeCall(() => Axios.get(`${url}/businesses`, { params, headers: getHeaders() })),
        getBusinessById: (id) => executeCall(() => Axios.get(`${url}/businesses/${id}`, { headers: getHeaders() })),
        createBusiness: (data) => executeCall(() => Axios.post(`${url}/businesses`, data, { headers: getHeaders() })),
        updateBusiness: (id, data) => executeCall(() => Axios.put(`${url}/businesses/${id}`, data, { headers: getHeaders() })),
        updateBusinessStatus: (id, status) => executeCall(() => Axios.patch(`${url}/businesses/${id}/status`, { status }, { headers: getHeaders() })),
        deleteBusiness: (id) => executeCall(() => Axios.delete(`${url}/businesses/${id}`, { headers: getHeaders() })),
        bulkDeleteBusinesses: (ids) => executeCall(() => Axios.post(`${url}/businesses/bulk-delete`, { ids }, { headers: getHeaders() })),
        bulkUpdateBusinessStatus: (ids, status) => executeCall(() => Axios.post(`${url}/businesses/bulk-status`, { ids, status }, { headers: getHeaders() })),

        // User bulk
        bulkDeleteUsers: (ids) => executeCall(() => Axios.post(`${url}/users/bulk-delete`, { ids }, { headers: getHeaders() })),
        bulkToggleUsers: (ids, action) => executeCall(() => Axios.post(`${url}/users/bulk-toggle`, { ids, action }, { headers: getHeaders() })),
        hardDeleteUser: (id) => executeCall(() => Axios.delete(`${url}/users/${id}/purge`, { headers: getHeaders() })),
        bulkHardDeleteUsers: (ids) => executeCall(() => Axios.post(`${url}/users/bulk-purge`, { ids }, { headers: getHeaders() })),
        restoreUser: (id) => executeCall(() => Axios.patch(`${url}/users/${id}/restore`, {}, { headers: getHeaders() })),

        // AI Risk Alerts
        getAiRiskAlerts: (params) => executeCall(() => Axios.get(`${url}/stats/ai-risk-alerts`, { params, headers: getHeaders() })),

        // AI Feature Config
        getAiConfig: () => executeCall(() => Axios.get(`${url}/ai-config`, { headers: getHeaders() })),
        searchAiTherapists: (q) => executeCall(() => Axios.get(`${url}/ai-config/search/therapists`, { params: { q }, headers: getHeaders() })),
        searchAiBusinesses: (q) => executeCall(() => Axios.get(`${url}/ai-config/search/businesses`, { params: { q }, headers: getHeaders() })),
        updateAiGlobal: (isEnabled) => executeCall(() => Axios.put(`${url}/ai-config/global`, { isEnabled }, { headers: getHeaders() })),
        upsertAiTherapist: (data) => executeCall(() => Axios.post(`${url}/ai-config/therapist`, data, { headers: getHeaders() })),
        removeAiTherapist: (id) => executeCall(() => Axios.delete(`${url}/ai-config/therapist/${id}`, { headers: getHeaders() })),
        upsertAiBusiness: (data) => executeCall(() => Axios.post(`${url}/ai-config/business`, data, { headers: getHeaders() })),
        removeAiBusiness: (id) => executeCall(() => Axios.delete(`${url}/ai-config/business/${id}`, { headers: getHeaders() })),
        acknowledgeAiAlert: (id) => executeCall(() => Axios.patch(`${url}/ai-risk/${id}/acknowledge`, {}, { headers: getHeaders() })),

        // Therapist stats (detail drawer)
        getTherapistStats: (id) => executeCall(() => Axios.get(`${url}/therapists/${id}/stats`, { headers: getHeaders() })),

        // Categories (especialidades) CRUD
        getCategories: () => executeCall(() => Axios.get(`${url}/categories`, { headers: getHeaders() })),
        createCategory: (data) => executeCall(() => Axios.post(`${url}/categories`, data, { headers: getHeaders() })),
        updateCategory: (id, data) => executeCall(() => Axios.put(`${url}/categories/${id}`, data, { headers: getHeaders() })),
        deleteCategory: (id) => executeCall(() => Axios.delete(`${url}/categories/${id}`, { headers: getHeaders() })),

        // Pricing config
        getConfig: () => executeCall(() => Axios.get(`${url}/config`, { headers: getHeaders() })),
        updateConfig: (key, value) => executeCall(() => Axios.put(`${url}/config`, { key, value }, { headers: getHeaders() })),
    };
};

export default admin;
